import { render } from "./Home.vue?vue&type=template&id=8dc7cce2&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=8dc7cce2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dc7cce2"],['__file',"src/components/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8dc7cce2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8dc7cce2', __exports__)) {
    api.reload('8dc7cce2', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=8dc7cce2&scoped=true&ts=true", () => {
    api.rerender('8dc7cce2', render)
  })

}


export default __exports__